import React, { Component } from 'react'
import { database } from '../../firebase'
import { ref, child, get } from 'firebase/database'
import { withRouter } from '../../withRouter'
import Title from '../components/Title'
import Loading from '../components/Loading'
import './ViewId.css'

const Row = (props) => (
  <div className='view_id__row'>
    <div className='view_id__row__name'>{props.name}</div>
    <div className='view_id__row__status'>
      {props.ready ? <i className='material-icons'>check_circle</i> : null}
    </div>
  </div>
)

class View extends Component {
  constructor (props) {
    super(props)
    this.state = {
      title: '',
      rows: [],
      loaded: false
    }
    this.rows = []
    this.dbRefG = ref(database, 'grupos')
    this.dbRefU = ref(database, 'usuarios/index')
  }
  componentDidMount () {
    const groupId = this.props.match.params.group
    const quinielaId = this.props.match.params.id
    const membersId = []
    const membersData = []
    let title
    get(child(this.dbRefG, 'index/' + groupId))
    .then((snap) => {
      title = snap.val().titulo
      return get(child(this.dbRefG, 'miembros/' + groupId))
    })
    .then((snap) => {
      const promises = []
      snap.forEach((child) => {
        membersId.push(child.key)
      })
      membersId.forEach((member, i) => {
        promises[i] = new Promise((resolve, reject) => {
          get(child(this.dbRefU, member + '/name'))
          .then((snap) => {
            membersData.push({
              id: member,
              name: snap.val()
            })
            resolve()
          })
          .catch((err) => {
            reject(err)
          })
        })
      })
      return Promise.all(promises)
    })
    .then(() => {
      membersData.sort((a, b) => {
        if (a.name > b.name) {
          return 1
        }
        if (a.name < b.name) {
          return -1
        }
        return 0
      })
      const promises = []
      membersData.forEach((member, i) => {
        promises[i] = new Promise((resolve, reject) => {
          let ready
          get(child(this.dbRefG, 'resultados/' + groupId + '/' + quinielaId + '/' + member.id))
          .then((snap) => {
            if (snap.val()) {
              ready = true
            } else {
              ready = false
            }
            this.rows.push({
              id: member.id,
              name: member.name,
              ready: ready
            })
            resolve()
          })
          .catch((err) => {
            reject(err)
          })
        })
      })
      return Promise.all(promises)
    })
    .then(() => {
      this.setState({
        title: title,
        rows: this.rows,
        loaded: true
      })
    })
    .catch((err) => {
      console.error(err)
    })
  }
  render () {
    if (this.state.loaded) {
      return (
        <div className='view_id'>
          <Title title='Consultar quiniela' />
          <div className='view_id__content'>
            <div className='view_id__content__header'>
              <h3>Estos son los resultados enviados para este grupo</h3>
            </div>
            <div className='view_id__content__body'>
              <h4>{this.state.title}</h4>
              {this.state.rows.map((row, i) => <Row key={i} name={row.name} ready={row.ready} />)}
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <div className='view_id'>
          <Title title='Consultar quiniela' />
          <div className='view_id__content view_id__content--loading'>
            <Loading />
          </div>
        </div>
      )
    }
  }
}

export default withRouter(View)
